(() => {
  const section = document.querySelector('.projet-hepia-gallery');
  if (!section) return;

  const rows = Array.from(section.querySelectorAll('.projet-hepia-gallery__row'));
  const rowTop = section.querySelector('.projet-hepia-gallery__row--top');
  const rowBottom = section.querySelector('.projet-hepia-gallery__row--bottom');
  if (!rows.length) return;

  // Desktop : parallaxe legere des rangees (+/- 10vw).
  // Sous 1024 px : chaque rangee est un bandeau horizontal (voir le CSS) que le scroll
  // fait defiler d'un bout a l'autre, une rangee sur deux en sens inverse.
  // Les galeries de 1 a 3 images restent fixes, et tout est coupe pour les visiteurs
  // qui demandent moins d'animations (le CSS garde alors la grille empilee).
  const mqDesktop = window.matchMedia('(min-width: 1024px)');
  const mqReduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fewImages = section.matches(
    '.projet-hepia-gallery--count-1, .projet-hepia-gallery--count-2, .projet-hepia-gallery--count-3'
  );
  // Le CSS anime deja les bandeaux mobiles quand le navigateur gere animation-timeline.
  const cssScroll = window.CSS && CSS.supports('animation-timeline: view()');
  const AMPLITUDE = 10;
  let ticking = false;
  let mode = 'off';

  const getProgress = () => {
    const rect = section.getBoundingClientRect();
    const viewH = window.innerHeight || document.documentElement.clientHeight;
    const raw = (viewH - rect.top) / (rect.height + viewH);
    return Math.max(0, Math.min(1, raw));
  };

  const update = () => {
    ticking = false;
    if (mode === 'desktop') {
      const shift = (getProgress() - 0.5) * 2 * AMPLITUDE;
      if (rowTop) rowTop.style.transform = `translate3d(${-shift}vw, 0, 0)`;
      if (rowBottom) rowBottom.style.transform = `translate3d(${shift}vw, 0, 0)`;
    } else if (mode === 'mobile') {
      // Course resserree entre 10 % et 90 % du passage : les premieres et dernieres
      // images sont vues pendant que la section est encore a l'ecran.
      const progress = Math.max(0, Math.min(1, (getProgress() - 0.1) / 0.8));
      const viewW = section.clientWidth;
      const overflows = rows.map((row) => Math.max(0, row.scrollWidth - viewW));
      rows.forEach((row, i) => {
        const p = i % 2 === 0 ? progress : 1 - progress;
        row.style.transform = `translate3d(${-p * overflows[i]}px, 0, 0)`;
      });
    }
  };

  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  };

  const sync = () => {
    let wanted = 'off';
    if (!mqReduced.matches) {
      if (mqDesktop.matches) wanted = 'desktop';
      else if (!fewImages && !cssScroll) wanted = 'mobile';
    }
    if (wanted === mode) return;
    mode = wanted;
    rows.forEach((row) => {
      row.style.transform = '';
    });
    if (mode === 'off') {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    } else {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  };

  [mqDesktop, mqReduced].forEach((mq) => {
    if (mq.addEventListener) mq.addEventListener('change', sync);
    else mq.addListener(sync);
  });
  sync();
})();
